import React from "react";

import {
  WelcomeScreen,
  AboutMe,
  Resume,
  Projects,
  Contact,
} from "./Components";

function App() {
  return (
    <>
      <WelcomeScreen />
      <AboutMe />
      <Resume />
      <Projects />
      <Contact />
    </>
  );
}

export default App;
